import { Box } from "@mui/system";
import type { FC } from "react";
import type { Severity } from "@/utils/models";
import { SeverityColors } from "./Utils/RecommendationsUtils";

interface IProps {
	severity: Severity;
}

export const RecommendationsColor: FC<IProps> = ({ severity }) => {
	return (
		<Box
			sx={{
				width: "12px",
				height: "12px",
				borderRadius: "50%",
				bgcolor: SeverityColors[severity],
				flexShrink: 0,
			}}
		/>
	);
};
